import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
// import Particle from "../Particle";
import Expense from "../../Assets/Projects/Expense.png";
import BackToTopButton from '../ExtraFeatures/BackToTopButton';
import Future from "../../Assets/Projects/chatify.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
import Notes from "../../Assets/Projects/Notes.png";
import Election from "../../Assets/Projects/Election.png";
import Snake from "../../Assets/Projects/Snake.png";
import Generate from "../../Assets/Projects/Generate.png";
import Archer from "../../Assets/Projects/Archer.png";
import Coaching from "../../Assets/Projects/Coaching.png";

export default function Projects() {
  return (
    <Container fluid className="project-section" id="project_id">
      {/* <Particle /> */}
      <BackToTopButton />
      <Container>
        <h1 className="project-heading">
          My Personal <strong className="purple">Projects </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          {/* 1st Project */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Future}
              isBlog={false}
              title="The Future Classes"
              description="Online Webpage which help student to choose perfect tutor available for them.
              We can call this website as a notes sharing website as well. Web Project [HTML, CSS, JS]"
              ghLink="https://github.com/Code-Asif/Online_Tutoring_Website"
              demoLink="https://code-asif.github.io/Online_Tutoring_Website/"
            />
          </Col>

          {/* 2nd Project */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Image Bit Manipulation"
              description="This is a small project that allow user to encrypt their file with cipher key and then decrypt that same file with cipher key. Java Application [Java, AWT, Swing]"
              ghLink="https://github.com/Code-Asif/Image_Pixel_Manipulation"
              demoLink="https://github.com/Code-Asif/Image_Pixel_Manipulation"
            />
          </Col>

          {/* 3rd Project */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Expense}
              isBlog={false}
              title="Expense Tracker"
              description="Online code and markdown editor build with react.js. Online Editor which supports html, css, and js code with instant view of website. Online markdown editor for building README file which supports GFM, Custom Html tags with toolbar and instant preview.Both the editor supports auto save of work using Local Storage"
              ghLink="https://github.com/Code-Asif/Expense_Tracker"
              demoLink="https://code-asif.github.io/Expense_Tracker/"              
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          {/* 4th Project */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Notes}
              isBlog={false}
              title="Notes"
              description="User can create their notes and download some popular notes as well. Java Application [Java OOP`s, Servlet, JSP, JDBC, MySQL]"
              ghLink="https://github.com/Code-Asif/AdvanceJavaProject_NotesCreateAndRead"
              demoLink="https://code-asif.github.io/Online_Tutoring_Website/"
            />
          </Col>

          {/* 5th Project */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Election}
              isBlog={false}
              title="Online Voting"
              description="Idea behind this project came from our classroom when we were discussing about that who`s going to be our CR. So, I thought to make a online voting system which can be used in any small contest like CR selection, College Head boy, etc. Java Application [Java OOP`s, Servlet, JSP, JDBC, MySQL]"
              ghLink="https://github.com/Code-Asif/OnlineVoting"
              demoLink="https://github.com/Code-Asif/OnlineVoting"
            />
          </Col>

          {/* 6th project */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Snake}
              isBlog={false}
              title="Old Snake Game"
              description="Simple old snake game which we used to play in our old Nokia phones. Java Application [Java OOP`s, AWT, Swing]"
              ghLink="https://github.com/Code-Asif"
              demoLink="https://github.com/Code-Asif"              
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          {/* 7th project */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Generate}
              isBlog={false}
              title="Generate List"
              description="This project generate a sub list randomly from your given input."
              ghLink="https://github.com/Code-Asif/Generate_Random_List"
              demoLink="https://code-asif.github.io/Generate_Random_List/"
            />
          </Col>

          {/* 8th project */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Image Bit Manipulation"
              description="My personal blog page build with Next.js and Tailwind Css which takes the content from makdown files and renders it using Next.js. Supports dark mode and easy to write blogs using markdown."
              ghLink="https://github.com/Code-Asif/Image_Pixel_Manipulation"
              demoLink="https://github.com/Code-Asif/Image_Pixel_Manipulation"
            />
          </Col>
        </Row>
      </Container>
      <Container >
      <h1 className="project-heading">
          Freelance <strong className="purple">Projects </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          {/* 1st Project */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Coaching}
              isBlog={false}
              title="Coaching"
              description="An ed-tech mobile application for an educational institute. It allow admin to upload study material, manage admission, fee, notices, user dashboard and many more."
              ghLink="https://github.com/Code-Asif/AA002"
              demoLink="https://asifalam.me/Distribution_NCCCC/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Archer}
              isBlog={false}
              title="Archer Foundation"
              description="A pamplate website for a educational institute name Archer Foundation for their advertisement and interested student can fill the apply for which form will directly received by owner"
              ghLink="http://asifalam.me/ArcherFoundation/"
              demoLink="http://asifalam.me/ArcherFoundation/"
            />
          </Col>
          </Row>
      </Container>
    </Container>
  );
}